import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'rk-footer-actions',
  templateUrl: './footer-actions.component.html',
  styleUrls: ['./footer-actions.component.scss'],
})
export class FooterActionsComponent {
  @Output()
  readonly cancelled = new EventEmitter();

  @Output()
  readonly submitted = new EventEmitter();

  @Input()
  disabledSubmit = false;

  @Input()
  submitText: string;

  @Input()
  cancelText: string;

  @Input()
  canCancel = true;

  @Input()
  @HostBinding('class.inline')
  inline = false;

  /*
  Negative margin (-20px) to handle content padding
   */
  @Input()
  @HostBinding('class.force-left')
  forceLeft = false;
}
